import {
  handleNonCaughtFetchError,
  throwTryCatchFetchError,
} from 'Main/fetch-helper';

export default {
  get(url) {
    return this.request(url);
  },

  post(url, data = {}) {
    return this.request(url, 'POST', data);
  },

  delete(url) {
    return this.request(url, 'DELETE');
  },

  async request(url, method = 'GET', data = {}) {
    let options = { method };

    if (method === 'POST') {
      options = {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        },

        body: JSON.stringify(data),
      };
    }

    try {
      const response = await fetch(`${lavendlaObituary.apiUrl}${url}`, options);

      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (!contentType?.includes('json')) {
          return null;
        }

        const text = await response.text();

        if (!text || !text.trim()) {
          return null;
        }

        return JSON.parse(text);
      }

      await handleNonCaughtFetchError(response);
    } catch (error) {
      throwTryCatchFetchError(error, 'Obituary API.request', {
        url,
        method,
        data,
      });
    }
  },
};
